import { takeLatest, put, call } from 'redux-saga/effects';
import {
  getLedgerDetailsSuccess,
  getLedgerDetailsFailure,
} from '../actions/ledgerDetails.action';
import { AnyAction } from 'redux';
import { GET_LEDGER_DETAILS_REQUEST } from '../constants/ActionTypes';
import { getLedgerDetailsApi } from '../api/RecruiterDashboard/backoffice.api';
import { showToast } from '../actions/toast.action';
import { EToastVariant } from 'do-front-end-utils';

function* getLedgerDetails(action: AnyAction): Generator<any, void, any> {
  try {
    const { companySlug, offset, productType, limit, from, to } =
      action.payload;
    const ledgerData = yield call(getLedgerDetailsApi, {
      offset,
      productType,
      limit,
      from,
      to,
      companySlug,
    });
    if (ledgerData?.meta) {
      yield put(
        getLedgerDetailsSuccess({
          result: ledgerData.results,
          count: ledgerData?.meta?.count,
          next: ledgerData?.meta?.next,
          previous: ledgerData?.meta?.previous,
        })
      );
    } else {
      yield put(getLedgerDetailsFailure('Meta data not found'));
      yield put(
        showToast({
          id: 'drd-ledger-details-error-toast',
          message: 'Meta data not found',
          variant: EToastVariant.SUCCESS,
        })
      );
    }
  } catch (error: unknown) {
    const errorMessage =
      error instanceof Error ? error.message : 'Unknown error';
    yield put(
      showToast({
        id: 'drd-ledger-details-error-toast',
        message: errorMessage,
        variant: EToastVariant.SUCCESS,
      })
    );
    yield put(getLedgerDetailsFailure(errorMessage));
  }
}

export default function* loadLedgerDetailsSaga() {
  yield takeLatest(GET_LEDGER_DETAILS_REQUEST, getLedgerDetails);
}
